import type { FulfillmentStatus } from "@longjie/shared";

export function formatDateTime(value: string): string {
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: "Asia/Shanghai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
    .format(new Date(value))
    .replaceAll("/", "-");
}

export function formatDate(value: string): string {
  const match = value.match(/^\d{4}-\d{2}-\d{2}/);
  return match?.[0] ?? value;
}

export function paymentLabel(status: "UNPAID" | "PARTIAL" | "PAID"): {
  label: string;
  tone: "warning" | "info" | "success";
} {
  if (status === "PAID") return { label: "已收款", tone: "success" };
  if (status === "PARTIAL") return { label: "部分收款", tone: "info" };
  return { label: "未收款", tone: "warning" };
}

export function fulfillmentLabel(status: FulfillmentStatus, deliveryMethod?: "SELF_PICKUP" | "DELIVERY"): {
  label: string;
  tone: "neutral" | "warning" | "info" | "success";
} {
  if (status === "COMPLETED") return { label: "已完结", tone: "success" };
  if (status === "DISPATCHED") return { label: deliveryMethod === "SELF_PICKUP" ? "已提货" : "已出车", tone: "info" };
  if (status === "PICKING") return { label: deliveryMethod === "SELF_PICKUP" ? "备货中" : "拣货中", tone: "warning" };
  return { label: "订单确认", tone: "neutral" };
}
